
import htmx from "htmx.org";
window.htmx = htmx;
window.htmx.config.globalViewTransitions = true;

document.addEventListener("astro:page-load", () => {
    
    const htmx = window.htmx;
    if (htmx) {
        htmx.process(document.body);
    }

});



import posthog from 'posthog-js'
window.posthog = posthog
if (true) {
    posthog.init('phc_bzXb0HsjhhKY6PS7pJ2lcjZYiWfRNSEAtGgHzuLNhVY', {"api_host":"https://r2.dev.sabal.finance/phg/","disable_session_recording":true,"autocapture":false,"capture_performance":false,"capture_heatmaps":false})
}

import { init } from 'astro/virtual-modules/prefetch.js';init()